import {
    BLURRED,
    CAMERA_ERROR,
    CODEC_ERROR,
    CONNECT_ERROR,
    ERROR,
    EXPIRED_DOCUMENT,
    INVALID_DOCUMENT,
    LIFE_PROOF_ERROR,
    LOW_QUALITY,
    NETWORK_ERROR,
    NON_EXCLUSIVE,
    QR_ERROR,
    SCREEN_PRINT_ERROR,
    WRONG_FACE_MATCH,
    DETECTION_TIMEOUT,
    CALLCENTER_KO,
    TOKEN_NOT_ALLOWED,
} from 'constants/video/status';
import { FOREIGN_DOCUMENT, INTERNATIONAL_DOCUMENT, NATIONAL_DOCUMENT } from 'constants/documentTypes';

export const VIDEOSELFIE_ERROR_MESSAGES = {
    LOW_QUALITY_MESSAGE: 'LOW_QUALITY_MESSAGE',
    NON_EXCLUSIVE_MESSAGE: 'NON_EXCLUSIVE_MESSAGE',
    ERROR_MESSAGE: 'ERROR_MESSAGE',
    CONNECT_ERROR_MESSAGE: 'CONNECT_ERROR_MESSAGE',
    EXPIRED_DOCUMENT_MESSAGE: 'EXPIRED_DOCUMENT_MESSAGE',
    WRONG_FACE_MATCH_MESSAGE: 'WRONG_FACE_MATCH_MESSAGE',
    CODEC_ERROR_MESSAGE: 'CODEC_ERROR_MESSAGE',
    BLURRED_MESSAGE: 'BLURRED_MESSAGE',
    CAMERA_ERROR_MESSAGE: 'CAMERA_ERROR_MESSAGE',
    SCREEN_PRINT_ERROR_MESSAGE: 'SCREEN_PRINT_ERROR_MESSAGE',
    LIFE_PROOF_ERROR_MESSAGE: 'LIFE_PROOF_ERROR_MESSAGE',
    INVALID_DOCUMENT_MESSAGE: 'INVALID_DOCUMENT_MESSAGE',
    INVALID_INTERNATIONAL_DOCUMENT_MESSAGE: 'INVALID_INTERNATIONAL_DOCUMENT_MESSAGE',
    INVALID_NATIONAL_DOCUMENT_MESSAGE: 'INVALID_NATIONAL_DOCUMENT_MESSAGE',
    INVALID_FOREIGN_DOCUMENT_MESSAGE: 'INVALID_FOREIGN_DOCUMENT_MESSAGE',
    NETWORK_ERROR_MESSAGE: 'NETWORK_ERROR_MESSAGE',
    DETECTION_TIMEOUT_MESSAGE: 'DETECTION_TIMEOUT_MESSAGE',
    QR_ERROR_MESSAGE: 'QR_ERROR_MESSAGE',
    CALLCENTER_KO_MESSAGE: 'CALLCENTER_KO_MESSAGE',
    TOKEN_NOT_ALLOWED_MESSAGE: 'TOKEN_NOT_ALLOWED_MESSAGE',
};

export const VIDEOSELFIE_ERROR_MESSAGES_TEXT = {
    [VIDEOSELFIE_ERROR_MESSAGES.LOW_QUALITY_MESSAGE]: 'identity-videoSelfieLowQuality',
    [VIDEOSELFIE_ERROR_MESSAGES.NON_EXCLUSIVE_MESSAGE]: 'identity-videoSelfieNonExclusive',
    [VIDEOSELFIE_ERROR_MESSAGES.ERROR_MESSAGE]: 'identity-videoSelfieError',
    [VIDEOSELFIE_ERROR_MESSAGES.CONNECT_ERROR_MESSAGE]: 'identity-videoCallConnectError',
    [VIDEOSELFIE_ERROR_MESSAGES.EXPIRED_DOCUMENT_MESSAGE]: 'identity-videoSelfieExpiredDocument',
    [VIDEOSELFIE_ERROR_MESSAGES.WRONG_FACE_MATCH_MESSAGE]: 'identity-videoSelfieWrongFaceMatch',
    [VIDEOSELFIE_ERROR_MESSAGES.CODEC_ERROR_MESSAGE]: 'identity-videoSelfieWrongCodec',
    [VIDEOSELFIE_ERROR_MESSAGES.BLURRED_MESSAGE]: 'identity-videoSelfieOtherItemsLights',
    [VIDEOSELFIE_ERROR_MESSAGES.CAMERA_ERROR_MESSAGE]: 'identity-videoSelfieOtherItemsCamera',
    [VIDEOSELFIE_ERROR_MESSAGES.SCREEN_PRINT_ERROR_MESSAGE]: 'identity-videoSelfieAttackTest',
    [VIDEOSELFIE_ERROR_MESSAGES.LIFE_PROOF_ERROR_MESSAGE]: 'identity-videoSelfieLifeProof',
    [VIDEOSELFIE_ERROR_MESSAGES.NETWORK_ERROR_MESSAGE]: 'identity-videoCallGenericNetworkErrorMessage',
    [VIDEOSELFIE_ERROR_MESSAGES.DETECTION_TIMEOUT_MESSAGE]: 'identity-detectionTimeoutErrorMessage',
    [VIDEOSELFIE_ERROR_MESSAGES.QR_ERROR_MESSAGE]: 'identity-videoCallGenericQRProcessErrorMessage',
    [VIDEOSELFIE_ERROR_MESSAGES.CALLCENTER_KO_MESSAGE]: 'messagesScreen-defaultErrorContent',
    [VIDEOSELFIE_ERROR_MESSAGES.INVALID_INTERNATIONAL_DOCUMENT_MESSAGE]:
        'identity-videoSelfieInvalidInternationalDocument',
    [VIDEOSELFIE_ERROR_MESSAGES.INVALID_NATIONAL_DOCUMENT_MESSAGE]: 'identity-videoSelfieInvalidNationalDocument',
    [VIDEOSELFIE_ERROR_MESSAGES.INVALID_FOREIGN_DOCUMENT_MESSAGE]: 'identity-videoSelfieInvalidForeignDocument',
    [VIDEOSELFIE_ERROR_MESSAGES.INVALID_DOCUMENT_MESSAGE]: 'identity-videoSelfieInvalidDocument',
    [VIDEOSELFIE_ERROR_MESSAGES.TOKEN_NOT_ALLOWED_MESSAGE]: 'identity-tokenNotAllowedErrorMessage',
};

export const VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE = {
    [LOW_QUALITY]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.LOW_QUALITY_MESSAGE],
    [NON_EXCLUSIVE]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.NON_EXCLUSIVE_MESSAGE],
    [ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.ERROR_MESSAGE],
    [CONNECT_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.CONNECT_ERROR_MESSAGE],
    [EXPIRED_DOCUMENT]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.EXPIRED_DOCUMENT_MESSAGE],
    [WRONG_FACE_MATCH]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.WRONG_FACE_MATCH_MESSAGE],
    [CODEC_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.CODEC_ERROR_MESSAGE],
    [BLURRED]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.BLURRED_MESSAGE],
    [CAMERA_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.CAMERA_ERROR_MESSAGE],
    [SCREEN_PRINT_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.SCREEN_PRINT_ERROR_MESSAGE],
    [LIFE_PROOF_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.LIFE_PROOF_ERROR_MESSAGE],
    [NETWORK_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.NETWORK_ERROR_MESSAGE],
    [DETECTION_TIMEOUT]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.DETECTION_TIMEOUT_MESSAGE],
    [QR_ERROR]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.QR_ERROR_MESSAGE],
    [CALLCENTER_KO]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.CALLCENTER_KO_MESSAGE],
    [INVALID_DOCUMENT]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.INVALID_DOCUMENT_MESSAGE],
    [TOKEN_NOT_ALLOWED]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.TOKEN_NOT_ALLOWED_MESSAGE],
};

export const INVALID_DOCUMENT_ERROR_TEXT_BY_DOCUMENT_TYPE_AGGREGATION = {
    [INTERNATIONAL_DOCUMENT]:
        VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.INVALID_INTERNATIONAL_DOCUMENT_MESSAGE],
    [NATIONAL_DOCUMENT]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.INVALID_NATIONAL_DOCUMENT_MESSAGE],
    [FOREIGN_DOCUMENT]: VIDEOSELFIE_ERROR_MESSAGES_TEXT[VIDEOSELFIE_ERROR_MESSAGES.INVALID_FOREIGN_DOCUMENT_MESSAGE],
};

export const DEFAULT_EXTRA_MESSAGE_QR_FLOW = 'identity-goToDesktopMessage';

export const EXTRA_MESSAGE_QR_FLOW_ERROR = {
    [DETECTION_TIMEOUT]: 'identity-refreshPageMessage',
    [CAMERA_ERROR]: 'identity-refreshPageMessage',
};

export const VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE = {
    [LOW_QUALITY]: `identity-videoCallGenericErrorMessage`,
    [NON_EXCLUSIVE]: `identity-videoCallGenericErrorMessage`,
    [ERROR]: `identity-videoCallGenericErrorMessage`,
    [CONNECT_ERROR]: 'identity-videoCallConnectError',
    [EXPIRED_DOCUMENT]: 'identity-videoCallExpiredDocument',
    [WRONG_FACE_MATCH]: 'identity-videoCallWrongFaceMatch',
    [CODEC_ERROR]: 'identity-videoCallWrongCodec',
};
